import { createSelector, TypedSelector } from '@ngxs/store';
import { HttpContentStateModel } from './http-content.model';

/** Base class for HTTP-backed NGXS slices; provides defaults and the trivial selectors. */
export class HttpContentState {
    public static defaults<T>(content: T): HttpContentStateModel<T> {
        return { isLoading: false, error: null, content };
    }

    public static isLoading(): TypedSelector<boolean> {
        return createSelector([this], (state: HttpContentStateModel<unknown>) => state.isLoading);
    }

    public static error(): TypedSelector<Error | null> {
        return createSelector([this], (state: HttpContentStateModel<unknown>) => state.error);
    }

    public static content<T>(): TypedSelector<T> {
        return createSelector([this], (state: HttpContentStateModel<T>) => state.content);
    }
}
